import styled from 'styled-components';
import { Colors } from '../../../../../../constants';

export const TrackingManagerContainer = styled.div`
  height: 22px;
  display: flex;  
  align-items: center;
`;

export const CheckBoxLabel = styled.span`
  display: block;
  margin-left: 8px;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-align: right;
  color: ${({ checked }) => (checked ? Colors.SECONDARY_BLUE : Colors.LIGHT_OPACITY_GREY)} !important;  
`;
